import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../lib/firebase";
import Logo from "../../components/Logo";

const MESSAGES = {
  "auth/invalid-credential": "E-posta veya şifre hatalı.",
  "auth/user-not-found": "Bu e-posta ile kullanıcı bulunamadı.",
  "auth/wrong-password": "Şifre hatalı.",
  "auth/too-many-requests": "Çok fazla deneme. Biraz sonra tekrar deneyin.",
  "auth/operation-not-allowed": "Firebase Console'da E-posta/Şifre girişi etkinleştirilmemiş.",
};

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError(MESSAGES[err.code] || `Giriş yapılamadı (${err.code}).`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <form className="card login__card" onSubmit={submit}>
        <Logo to="/" />
        <div>
          <h2 style={{ fontSize: "1.3rem", marginBottom: 4 }}>Yönetim paneli</h2>
          <p className="muted" style={{ margin: 0, fontSize: ".9rem" }}>Tema ve site bilgilerini düzenlemek için giriş yapın.</p>
        </div>
        <div className="field">
          <label htmlFor="a-email">E-posta</label>
          <input id="a-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required />
        </div>
        <div className="field">
          <label htmlFor="a-pass">Şifre</label>
          <input id="a-pass" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
        </div>
        {error && <div className="alert alert--error">{error}</div>}
        <button className="btn btn--primary btn--lg" disabled={busy}>
          {busy ? "Giriş yapılıyor…" : "Giriş yap"}
        </button>
      </form>
    </div>
  );
};

export default Login;
